/**
 * 数据源数据查询相关常量
 */
import i18next from "../global/i18n";


export const PROP_SUFFIX_CONNECTOR = '__';

export const SYSTEM_COLUMN_LIST = () => ([
    {
      label: i18next.t('functionParser.datasource.systemColumns.selected'), // 数据状态-是否选中
      value: '$selected'
    }
  ]
);

export const PAGING_COLUMN_LIST = () => ([{
    label: i18next.t('functionParser.datasource.pagingColumns.page'),   // 数据源分页参数-页码
    value: 'page'
  },
    {
      label: i18next.t('functionParser.datasource.pagingColumns.size'),    // 数据源分页参数-每页数量
      value: 'size'
    },
    {
      label: i18next.t('functionParser.datasource.pagingColumns.total'),    // 数据源分页参数-总数
      value: 'total'
    }]);

export const DATASOURCE_ATTR_LIST = () => ([{
    label: i18next.t('functionParser.datasource.datasourceAttr.items'),     // 数据源参数-数据列表
    value: 'items'
  }]);
export const USER_INFO_LIST = ()=> ([
  {
    label: i18next.t('functionParser.datasource.userInfo.id'),     // 当前用户-用户ID
    value: 'id'
  },
  {
    label: i18next.t('functionParser.datasource.userInfo.name'),    // 当前用户-用户名称
    value: 'name'
  },
  {
    label: i18next.t('functionParser.datasource.userInfo.avatar'),    // 当前用户-头像
    value: 'avatar'
  },
  {
    label: i18next.t('functionParser.datasource.userInfo.userType'),    // 当前用户-用户类型
    value: 'userType'
  }]);

export const PARAM_TYPE_MAP = ()=> ({
  FORM_FIELD: 'form_field',
  SYSTEM_FIELD: 'system_field',
  PAGING_PARAMS: 'paging_params',
  CURRENT_USER: 'current_user',
  DATASOURCE_ATTR: 'datasource_attr',
  FORM_ROW: 'form_row'
});

export const RELATION_TYPE_LIST = ()=> ([
  {
    label: i18next.t('functionParser.datasource.relationTypes.oneToMany'),   // 一对多
    value: '1:N'
  },
  {
    label: i18next.t('functionParser.datasource.relationTypes.manyToMany'),    // 多对多
    value: 'M:N'
  }]);

export const RELATION_TYPE_MAP = ()=> ({
  ONE_TO_MANY: '1:N',
  MANY_TO_MANY: 'M:N'
});

export const FiledTypeList = ()=> ([
  {
    label: i18next.t('functionParser.datasource.paramTypes.formField'),     // 表单字段
    value: PARAM_TYPE_MAP().FORM_FIELD,
    children: [],
  },
  {
    label: i18next.t('functionParser.datasource.paramTypes.currentUser'),   // 用户信息
    value: PARAM_TYPE_MAP().CURRENT_USER,
    children: _cloneDeep(USER_INFO_LIST()),
  },
  {
    label: i18next.t('functionParser.datasource.paramTypes.systemField'),     // 系统字段
    value: PARAM_TYPE_MAP().SYSTEM_FIELD,
    children: _cloneDeep(SYSTEM_COLUMN_LIST()),
  },
  {
    label: i18next.t('functionParser.datasource.paramTypes.pagingParams'),     // 分页参数
    value: PARAM_TYPE_MAP().PAGING_PARAMS,
    children: _cloneDeep(PAGING_COLUMN_LIST()),
  },
  {
    label: i18next.t('functionParser.datasource.paramTypes.datasourceAttr'),    // 数据源参数
    value: PARAM_TYPE_MAP().DATASOURCE_ATTR,
    children: _cloneDeep(DATASOURCE_ATTR_LIST()),
  },
  {
    label: i18next.t('functionParser.datasource.paramTypes.formRow'),   // 表单行数据
    value: PARAM_TYPE_MAP().FORM_ROW,
    children: [],
  },
]);

export function getTypeMap(TypeList) {
  let TypeMap = {};
  for (let it of TypeList) {
    TypeMap[it.value] = it;
    TypeMap[it.value].children = it.children || [];
  }
  return TypeMap
}
